
import { defineComponent } from "vue";
import { TableEditingConfig } from "@/components/controls/catalogueGrid/tableEditingConfig";
import { TableSelectionConfig } from "@/components/controls/catalogueGrid/tableSelectionConfig";
import { TableDesignConfig } from "@/components/controls/catalogueGrid/tableDesignConfig";
import { TextColumnConfig } from "@/components/controls/catalogueGrid/columns/textColumnConfig";
import CatalogueGrid from "@/components/controls/catalogueGrid/CatalogueGrid.vue";
import { DecimalColumnConfig } from "@/components/controls/catalogueGrid/columns/decimalColumnConfig";

export default defineComponent({
  components: {
    CatalogueGrid,
  },
  props: {
    //показатель режима выбора
    selectMode: { required: false, type: Boolean, default: false },
    gridHeight: { required: false, type: String, default: null },
    //функция для получения выбранных элементов
    getSelectedData: { type: Function },
    //функция для вызова при изменении выбранных элементов
    changeSelectedData: { type: Function },
    //модель родительского элемента
    parentModel: { required: true },
  },
  methods: {
    onRowPrepared(e: any) {
      if (e.rowType == "header"){
        e.rowElement.bgColor = "#E5F0FF";
      }
    },
    changeView(){
      this.$emit("change-view", false);
    },
  },
  data() {
    return {
      toolbarItems: [
        {
          location: "before",
          widget: "dxButton",
          options: {
            text: "Без сверки с остатками",
            stylingMode: "outlined",
            onClick: this.changeView,
          },
        },
      ],
      // подробности работы custom summary см. на сервере в методе SetCustomSummary
      summaryConfig: {
        totalItems: [
          {
            name: "TotalSummary",
            showInColumn: "cut",
            displayFormat: "Итог:",
            summaryType: "custom",
          },
          {
            name: "LoadedVolumeSummary",
            showInColumn: "loadedVolume",
            column: "loadedVolume",
            valueFormat: "#,##0.#",
            displayFormat: "{0} м³",
            summaryType: "sum",
          },
          {
            name: "StorageVolumeSummary",
            showInColumn: "storageVolume",
            column: "storageVolume",
            valueFormat: "#,##0.#",
            displayFormat: "{0} м³",
            summaryType: "sum",
          },
          {
            name: "RemainderSummary",
            showInColumn: "remainder",
            column: "remainder",
            valueFormat: "#,##0.#",
            displayFormat: "{0} м³",
            summaryType: "sum",
          },
        ],
      },
      editingConfig: new TableEditingConfig({
        allowDeleteAll: false,
        allowUpdating: false,
        allowAdding: false,
        allowDeleting: false,
        confirmDelete: true,
        allowDataFill: false,
        allowExport: false,
        allowImport: false,
        allowClearFilter: true,
        allowDeleteMultipleRows: false,
        allowColumnReordering: true,
        enableMasterDetail: true,
        detailComponentName:
          "components/journals/PlanPackageResultJournal/PlanPackageResultDetailedRollupJournal.vue",
        mode: "row",
        chooseColumns: false,
      }),
      selectModeEditingConfig: new TableEditingConfig({
        allowUpdating: false,
        allowAdding: false,
        allowDeleting: false,
        confirmDelete: false,
        allowDataFill: false,
        allowExport: false,
        allowDeleteMultipleRows: false,
      }),
      columns: [
        new TextColumnConfig({
          dataField: "cut",
          caption: "Сечение",
        }),

        new TextColumnConfig({
          dataField: "lengthRange",
          caption: "Длина",
        }),

        new TextColumnConfig({
          dataField: "order",
          caption: "№ заказа",
        }),

        new DecimalColumnConfig({
          dataField: "loadedVolume",
          caption: "Погружено (м³)",
          decimalPoints: 1,
        }),

        new DecimalColumnConfig({
          dataField: "storageVolume",
          caption: "Склад (м³)",
          decimalPoints: 1,
        }),

        new DecimalColumnConfig({
          dataField: "remainder",
          caption: "Остаток (м³)",
          decimalPoints: 1,
        }),
      ],
      designConfig: new TableDesignConfig({
        popUpColumnsCount: 1,
        popUpWidth: "850px",
        horizontalScroll: false,
      }),
      selectionConfig: new TableSelectionConfig({
        mode: "multiple",
        selectAllMode: "allPages",
        showCheckBoxesMode: "none",
      }),
      pageSizes: [10, 20, 50, 100],
    };
  },
  created() {
    if (this.selectMode) {
      this.editingConfig = this.selectModeEditingConfig;
    }
    if (this.gridHeight) {
      this.designConfig.height = this.gridHeight;
    }
  },
});
